import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';

    angular.module('app.core').component('kissInvitedEntityAutocompleteFilter', {
        bindings: {
            invitedEntitySelected: '=',
            duplicateInvitedEntity: '@', // True pour autoriser l'affichage de plusieurs fournisseurs appartenent à la même société. False pour dédoublonner. False par défaut
            status: '@', // Filtre sur un statut
        },
        controller: InvitedEntityAutocompleteFilterController,
        templateUrl: require('./invited-entity-autocomplete-filter.html'),
    });

    InvitedEntityAutocompleteFilterController.$inject = ['invitedEntitySvc'];

    function InvitedEntityAutocompleteFilterController(invitedEntitySvc) {
        var ctrl = this;

        ctrl.searchInvitedEntitys = searchInvitedEntitys;

        /**
         * Recherche des comptes invités en autocomplétion.
         */
        function searchInvitedEntitys(value) {
            if (value && value.length >= 3) {
                return invitedEntitySvc.searchInvitedEntitys(value).then(function (invitedEntitys) {
                    let invitedEntitysFiltered;
                    if (ctrl.duplicateInvitedEntity) {
                        invitedEntitysFiltered = invitedEntitys;
                    } else {
                        invitedEntitysFiltered = _.uniqBy(invitedEntitys, 'legalEntity.id');
                    }
                    if (ctrl.status) {
                        invitedEntitysFiltered = _.filter(invitedEntitys, { status: ctrl.status });
                    }
                    return invitedEntitysFiltered;
                });
            }
        }
    }
})();
